import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dropdown } from "semantic-ui-react";
import { setPVDataUnit } from "../../redux/pvData";
import { usePVColorBar } from "../CustomHooks";
import { CustomColorBar } from "./ColorBarComponent";
import { COLORBAR_GRADIENT } from "./colorbarConstants";
import "./colorBar.css";

const PVDataUnitSelector = () => {
  const { unit, unitOptions } = useSelector((state) => state.pvData);
  const dispatch = useDispatch();

  const dropDownOptions = unitOptions.map((option) => ({
    key: option,
    text: option,
    value: option,
    content: option,
  }));

  return (
    <Dropdown
      className="colorbar-unit-dropdown"
      direction="left"
      onChange={(e, { value }) => dispatch(setPVDataUnit(value))}
      options={dropDownOptions}
      value={unit}
      inline
    />
  );
};

const ColorBarPV = () => {
  const { isVisible, subcategory, minVal, maxVal } = usePVColorBar();
  return (
    <CustomColorBar
      gradient={COLORBAR_GRADIENT.PV}
      category="PV Panel"
      subcategory={subcategory}
      unit={() => <PVDataUnitSelector />}
      dataMin={minVal}
      dataMax={maxVal}
      isVisible={isVisible}
    />
  );
};

export default ColorBarPV;
